const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  OPEN_API_BASE_URL: process.env.REACT_APP_OPEN_API_BASE_URL,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL,
};

const BATCH_MAX_FILE_SIZE = 10; // 10MB
const MAX_FILE_SIZE = 3; // 3MB
const QUICK_SEND_MAX_CHARACTERS = 536;

const LoadingStatus = {
  idle: 'idle',
  pending: 'pending',
  fulfilled: 'fulfilled',
  rejected: 'rejected',
};

const StorageKey = {
  authUser: '@auth:user',
};

const ROUTES = {
  ROOT_PATH: '/',
  DASHBOARD_PATH: '/dashboard',
  LOGIN_PATH: '/signin',
  SIGNUP_PATH: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/update-password',
  SUBSCRIPTIONS: {
    INDEX: '/subscriptions',
    SUBSCRIBE: '/subscriptions/:id/subscribe',
    LIST: '/subscriptions/list',
  },
  TRANSACTIONS: {
    INDEX: '/transactions',
    DETAIL: '/transactions/:id',
  },
  SMS: {
    INDEX: '/sms',
  },
  REPORTS: {
    INDEX: '/reports',
  },
  CONTACT_US: '/contact-us',
  API: '/apis',
  SERVER_ERROR: '/500',
};

const NOTIFCATION_MESSAGE_CONFIG = {
  placement: 'bottom',
  duration: 2.5,
  className: 'sms-message',
};

const SMS_STATUSES = [
  {
    value: 1,
    label: 'Pending',
  },
  {
    value: 2,
    label: 'Processing',
  },
  {
    value: 3,
    label: 'Completed',
  },
  {
    value: 4,
    label: 'Failed',
  },
];

const SMS_TYPES = [
  {
    value: 1,
    label: 'OTP',
  },
  {
    value: 2,
    label: 'Marketing',
  },
];

const TRANSACTION_STATUSES = {
  to_pay: {
    value: 1,
    text: 'to_pay',
  },
  paid: {
    value: 2,
    text: 'paid',
  },
  completed: {
    value: 3,
    text: 'completed',
  },
  rejected: {
    value: 4,
    text: 'rejected',
  },
};

const SENDER_CONSTANT = {
  STATUSES: [
    {
      label: 'Active',
      value: 1,
    },
    {
      label: 'Pending',
      value: 2,
    },
    {
      label: 'Blocked',
      value: 3,
    },
    {
      label: 'Disapproved',
      value: 4,
    },
    {
      label: 'Expired',
      value: 5,
    },
  ],
  USE_TYPES: [
    {
      label: 'OTP',
      value: 1,
    },
    {
      label: 'Marketing',
      value: 2,
    },
  ],
};

const SMS_TEMPLATE_CONSTANT = {
  STATUSES: [
    {
      label: 'Enable',
      value: true,
    },
    {
      label: 'Disable',
      value: false,
    },
  ],
};

const LOG_TYPES = [
  {
    label: 'Top Up',
    value: 1,
  },
  {
    label: 'Used',
    value: 4,
  },
  {
    label: 'Refund',
    value: 5,
  },
];

const SEND_TYPES = [
  {
    label: 'QUICK_SEND',
    value: 1,
  },
  {
    label: 'SEND_USING_FILE',
    value: 2,
  },
  {
    label: 'API_OTP',
    value: 3,
  },
  {
    label: 'API_MARKETING',
    value: 4,
  },
];

const PAGE_SIZE = 10;

const SEND_USING_FILES_SEND_TYPES = {
  sendNow: 'send_now',
  scheduleCampaign: 'schedule_campaign',
};

const GATEWAY_STATUSES = [
  {
    value: 1,
    label: 'Pending',
  },
  {
    value: 2,
    label: 'Processing',
  },
  {
    value: 3,
    label: 'Completed',
  },
  {
    value: 4,
    label: 'Failed',
  },
];

export {
  ENV,
  ROUTES,
  LoadingStatus,
  StorageKey,
  NOTIFCATION_MESSAGE_CONFIG,
  SMS_STATUSES,
  TRANSACTION_STATUSES,
  SENDER_CONSTANT,
  PAGE_SIZE,
  SMS_TEMPLATE_CONSTANT,
  BATCH_MAX_FILE_SIZE,
  SMS_TYPES,
  LOG_TYPES,
  MAX_FILE_SIZE,
  QUICK_SEND_MAX_CHARACTERS,
  SEND_TYPES,
  SEND_USING_FILES_SEND_TYPES,
  GATEWAY_STATUSES,
};
